function Carousel(options, className) {

    // Options
    this.options = {
        arrows: true,
        dots: true,
        prevArrow: 'arrow-left-large',
        nextArrow: 'arrow-right-large'
    };

    $.extend(this.options, options);

    this.options.prevArrow = slickArrow(this.options.prevArrow, 'prev');
    this.options.nextArrow = slickArrow(this.options.nextArrow, 'next');

    // Variables
    this.className = 'js-carousel--';
    this.breakpoint;

    // Public functions
    this.init = init;
    this.activate = activate;
    this.watch = watch;
    this.unslickable = unslickable;

    // Functions

    // Set up a carousel
    function init(el) {
        var self = this;

        // Assign the classname of the carousel element
        this.className += className;

        if (this.options.arrows) {
            el.addClass('carousel--has-arrows');
        }

        if (this.options.dots) {
            el.addClass('carousel--has-dots');
        }

        // Is the carousel responsive?
        if (this.options.responsive) {
            // If so, is it unslickable (is slick unset at a particular breakpoint)?
            if (this.unslickable()) {
                // If we start at the small breakpoint, we need to be ready to reinit for the large breakpoint
                if (this.options.mobileFirst) {
                    if (window.matchMedia('(min-width : ' + this.breakpoint + 'px)').matches) {
                        this.watch();
                    }
                } else {
                    if (window.matchMedia('(max-width : ' + this.breakpoint + 'px)').matches) {
                        this.watch();
                    }
                }
                // If we destroy the carousel, we need to be ready to reinit
                $('.' + this.className).on('destroy', function(e, slick) {
                    $(this).attr('data-carousel-active', false);
                    self.watch();
                });
            }
        }

        // Init the carousel
        this.activate();
    }

    // Init the carousel
    function activate() {
        $('.' + this.className).attr('data-carousel-active', true);
        $('.' + this.className).slick(this.options);
    }

    // Watch for resize events
    function watch() {
        var self = this;
        var resize;
        $(window).off('resize.' + this.className).on('resize.' + this.className, function() {
            clearTimeout(resize);
            resize = setTimeout(function() {
                if (self.options.mobileFirst) {
                    if (window.matchMedia('(max-width : ' + self.breakpoint + 'px)').matches) {
                        self.activate();
                        $(window).off('resize.' + self.className);
                    }
                } else {
                    if (window.matchMedia('(min-width : ' + self.breakpoint + 'px)').matches) {
                        self.activate();
                        $(window).off('resize.' + self.className);
                    }
                }
            }, 100);
        });
    }

    // Is the carousel unslickable?
    function unslickable() {
        var unslick = false;
        for (var i = 0; i < this.options.responsive.length; i++) {
            if (this.options.responsive[i].settings == 'unslick') {
                this.breakpoint = this.options.responsive[i].breakpoint;
                unslick = true;
            }
        }
        return unslick;
    }

    function slickArrow(icon, action) {
        return '<div class="slick-arrow slick-arrow--' + className + ' slick-' + action + '">' +
            '<svg class="icon icon-' + icon + '">' +
            '<use xlink:href="/images/svg-symbols.svg#icon-' + icon + '" />' +
            '</svg>' +
            '</div>'
    }
}
